const t = "_iconRight_1xc8n_1", c = {
  iconRight: t
};
export {
  c as default,
  t as iconRight
};
